// extracted by mini-css-extract-plugin
export default {"wrapper":"Item_wrapper__Sszsu","remove":"Item_remove__czZT2","image":"Item_image__AsXMD"};